import { useTranslation } from '../hooks/useTranslation'

export function ResearchersPage() {
  const { t } = useTranslation()
  return (
    <div className="p-6">
      <h1 className="text-h1 text-text-primary mb-2">{t('researchers.title')}</h1>
      <p className="text-body text-text-secondary">{t('researchers.coming_soon')}</p>
    </div>
  )
}
